var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPhoneBool && !_vm.collapsed)?_c('div',{staticClass:"d-flex pl-2"},_vm._l((_vm.buttonlist),function(button){return _c(button,{key:button,tag:"component",attrs:{"small":true}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }